import React from 'react';

import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';

import _get from 'lodash/get';

import { ObjectPropType } from 'libs/proptypes';

import { getComponentForSetting } from './PushSettings.utils';
import HelpTooltip from '../../../../../../../common/HelpTooltip';
import {
  locationCanUploadMenu,
  locationCanUploadServices,
} from '../../../../../../business-profile/services/gbp';
import useBranding from '../../../../../../foundation/hooks/use-branding';
import { MENU_SETTING, SERVICES_SETTING } from '../../AccountSettings.constants';
import { GoogleLocationPropType } from '../../AccountSettings.types';
import { getDisplaySyncSetting, getPushHelpTooltip } from '../../AccountSettings.utils';

import './PushSettings.scss';

const propTypes = {
  setting: ObjectPropType.isRequired,
  name: PropTypes.string.isRequired,
  location: GoogleLocationPropType.isRequired,
  onSettingChange: PropTypes.func.isRequired,
};

const defaultProps = {};

function PushSettings({ setting, name, location, onSettingChange }) {
  const { brandName, menuLabel } = useBranding();

  const isMenu = name === MENU_SETTING;
  const isServices = name === SERVICES_SETTING;

  const canUploadMenu = locationCanUploadMenu(location);
  const canUploadServices = locationCanUploadServices(location);

  const { push } = setting;
  const pushSupported = _get(push, 'supported');

  if (!pushSupported) {
    return null;
  }

  const displayName = getDisplaySyncSetting(name, brandName, menuLabel);
  const pushHelpTooltip = getPushHelpTooltip(name, brandName, menuLabel);

  const EnableComponent = getComponentForSetting(name);

  let displayEnableComponent = true;

  if (isMenu || isServices) {
    if (!canUploadMenu && !canUploadServices) {
      displayEnableComponent = false;
    }
  }

  return (
    <Table.Row className="push">
      <Table.Cell className="name">
        Sync {displayName} to Google
        <HelpTooltip title={displayName} content={pushHelpTooltip} />
      </Table.Cell>
      <Table.Cell className="toggle">
        {displayEnableComponent && (
          <EnableComponent actionSettings={push} onChange={onSettingChange} />
        )}
        {!displayEnableComponent && (
          <>
            <span>Google Business Profile Location is not eligible for a {menuLabel} Sync.</span>
            <br />
            <span>Please review your Business Category in Google Business Profile</span>
          </>
        )}
      </Table.Cell>
    </Table.Row>
  );
}

PushSettings.propTypes = propTypes;
PushSettings.defaultProps = defaultProps;

export default PushSettings;
